export var Feature;
(function (Feature) {
    Feature["AgentMessageCount"] = "AgentMessageCount";
    Feature["ImageGenerationCount"] = "ImageGenerationCount";
    Feature["CreditBalance"] = "CreditBalance";
})(Feature || (Feature = {}));
//# sourceMappingURL=feature.const.js.map